import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from "recharts";
import { useEffect, useState } from "react";
import { api } from "../lib/api";

export const SkillRadar = ({ employeeId, targetRoleId, height = 280 }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!employeeId) return;
    setLoading(true);
    api
      .get(`/employees/${employeeId}/skill-radar`, { params: { mode: "auto", ...(targetRoleId ? { target_role_id: targetRoleId } : {}) } })
      .then((r) => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [employeeId, targetRoleId]);

  if (loading) {
    return (
      <div className="card-surface p-5 flex items-center justify-center" style={{ height }} data-testid="skill-radar-loading">
        <div className="text-xs text-slate-500">Radar hazırlanıyor…</div>
      </div>
    );
  }
  if (!data?.axes?.length) return null;

  const isIndividual = data.mode === "individual";
  const chartData = data.axes.map((a) => ({
    cluster: isIndividual
      ? (a.skill_name || a.skill_id || "").slice(0, 14)
      : a.cluster_name.split(" ").slice(0, 2).join(" "),
    fullName: isIndividual ? `${a.skill_name} · ${a.cluster_name}` : a.cluster_name,
    mevcut: a.current,
    hedef: a.target,
  }));

  return (
    <div className="card-surface p-5" data-testid={`skill-radar-${employeeId}`}>
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="label-eyebrow mb-1">Yetkinlik Radarı</div>
          <div className="text-xs text-slate-500">Hedef: <span className="text-slate-800 font-medium">{data.target_role.title}</span></div>
        </div>
        <div className="flex items-center gap-3 text-[0.7rem]">
          <span className="inline-flex items-center gap-1">
            <span className="w-2.5 h-2.5 rounded-sm bg-sky-500" /> Mevcut
          </span>
          <span className="inline-flex items-center gap-1">
            <span className="w-2.5 h-2.5 rounded-sm border-2 border-amber-500" /> Hedef
          </span>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={height}>
        <RadarChart data={chartData} margin={{ top: 8, right: 28, bottom: 8, left: 28 }}>
          <PolarGrid stroke="#CBD5E1" />
          <PolarAngleAxis dataKey="cluster" tick={{ fill: "#475569", fontSize: 11, fontWeight: 500 }} />
          <PolarRadiusAxis angle={90} domain={[0, data.max_level || 5]} tick={{ fill: "#94A3B8", fontSize: 10 }} />
          <Radar name="Hedef" dataKey="hedef" stroke="#D97706" fill="#F59E0B" fillOpacity={0.10} strokeDasharray="4 3" strokeWidth={2} />
          <Radar name="Mevcut" dataKey="mevcut" stroke="#0284C7" fill="#0EA5E9" fillOpacity={0.35} strokeWidth={2} />
          <Tooltip
            contentStyle={{ background: "#FFFFFF", border: "1px solid #E2E8F0", borderRadius: 8, fontSize: 12 }}
            labelFormatter={(label, payload) => payload?.[0]?.payload?.fullName || label}
            formatter={(value) => [`${value} / ${data.max_level}`, ""]}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SkillRadar;
